"use client"
import "./Spinner.css"

export default function Spinner() {
    return (
        <div className="spinner-overlay">
            <div className="spinner-container">
                <div className="spinner-part rotate-clockwise">
                    <svg width="50" height="50" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
                        <g>
                            <path
                                fill="#F24535"
                                d="M247.5,294.8h-64.5c-10,16.9-27.6,28.5-49.8,28.5c-35.1,0-58.6-28.2-58.6-61.4v-0.6
                c0-33.2,23.8-62,59.2-62c21.9,0,39.2,11,48.9,27.6h65.2h2.5v-6.3c-16.6-46-61.4-78.9-116.8-78.9C62.7,141.6,10,194.5,10,260.3v0.6
                c0,66.1,53.3,119.4,124.1,119.4c55.4,0,99.6-32.3,116.2-78v-7.5H247.5z"
                            />
                        </g>
                    </svg>
                </div>
                <div className="spinner-part rotate-counterclockwise">
                    <svg width="50" height="50" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
                        <g>
                            <path
                                fill="#F24535"
                                d="M366.5,380.3c70.8,0.3,124.1-53.3,124.1-119v-0.6c0-66.1-52.3-119-123.4-119
                c-55.4,0-100.2,32.9-116.8,78.9v6.3h1.9h65.2c9.7-16.6,27.3-27.6,48.9-27.6c35.1,0,59.2,28.8,59.2,62v0.6h0.3
                c0,33.2-23.2,61.4-58.6,61.4c-21.9,0-39.8-11.6-49.8-28.5h-64.5h-2.5v7.5c0,0,0,0,0,0C266.9,348,311.1,380.3,366.5,380.3z"
                            />
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    )
}

